<template lang="pug">
  .hidden.lg-block.absolute.left-0.w-full.px-12.pointer-events-none(v-if="notes")
    .ml-13x18.w-3x18.px-12.font-mono.text-gray-500.tracking-40.mb-em.pointer-events-auto(v-for="note in notes")
      | {{note.number}}.&nbsp;
      prismic-rich-text.inline.children-inline(:field="note.footnote")
</template>

<script>
import _get from 'lodash/get'
export default {
  name: 'Footnote',
  props: ['slice', 'footnotes'],
  computed: {
    numbers () {
      const nmbs = _get(this.slice, 'primary.insert_footnotes')
      if (!nmbs) return null
      const parsed = String(nmbs).split(',').map(n => parseInt(n, 10)).filter(n => !isNaN(n))
      return parsed.length ? parsed : null
    },
    notes () {
      if (!this.footnotes || !this.numbers) return null
      // the text can pin a number with no matching footnote row, or a row whose No. box was left
      // empty in Prismic (3 projects): those must not reach the template or the render fails
      const found = this.numbers
        .map(n => this.footnotes.find(note => note && note.number === n))
        .filter(Boolean)
      return found.length ? found : null
    }
  },
  inheritAttrs: false
}
</script>

<style>
</style>
